import React, { useMemo } from 'react';

import Grid from './Grid';
import Map from './Map';
import { stadiumContentLayout } from './helpers';
import style from './style.module.scss';

const StadiumSheet = ({
  entries, tileBoxes, selectedLabels, showBoxes, onOpenDetail, loading,
}) => {
  const { stageW, stageH, slots } = useMemo(
    () => stadiumContentLayout(entries || []),
    [entries],
  );

  return (
    <div className={style.stadiumStage} style={{ width: stageW, height: stageH }}>
      {slots.map((slot, i) => (
        <div
          key={slot.scanId || `slot-${i}`}
          className={style.stadiumSlot}
          style={{
            left: slot.left,
            top: slot.top,
            width: slot.width,
            height: slot.height,
            transform: `translate(-50%, -50%) rotate(${slot.angle}deg)`,
          }}
        >
          <Grid
            scan={slot.scan}
            tiles={slot.tiles}
            rows={slot.rows}
            cols={slot.cols}
            tileBoxes={tileBoxes}
            selectedLabels={selectedLabels}
            showBoxes={showBoxes}
            onOpenDetail={onOpenDetail}
            loading={loading}
            boxKeyPrefix={slot.scanId}
            variant="slot"
            slotWidth={slot.width}
            slotHeight={slot.height}
          />
        </div>
      ))}
    </div>
  );
};

const Preview = ({
  showStadium,
  showRegion,
  shimmer,
  optionValue,
  stadiumEntries,
  singleScan,
  tiles,
  rows,
  cols,
  tileBoxes,
  selectedLabels,
  showBoxes,
  onOpenDetail,
  scanLoading,
}) => {
  if (showStadium) {
    return (
      <div className={style.previewPane}>
        <Map key={optionValue} fit="contain">
          <StadiumSheet
            entries={stadiumEntries}
            tileBoxes={tileBoxes}
            selectedLabels={selectedLabels}
            showBoxes={showBoxes}
            onOpenDetail={onOpenDetail}
            loading={scanLoading}
          />
        </Map>
      </div>
    );
  }

  if (!showRegion) return null;

  return (
    <div className={style.previewPaneHug}>
      <Map key={optionValue} fit="content">
        <Grid
          scan={singleScan}
          tiles={shimmer ? [] : tiles}
          rows={rows}
          cols={cols}
          tileBoxes={tileBoxes}
          selectedLabels={selectedLabels}
          showBoxes={showBoxes}
          onOpenDetail={onOpenDetail}
          loading={shimmer}
        />
      </Map>
    </div>
  );
};

export default Preview;
